import { useMemo } from "react";
import MapPin from "../../../../assets/icons/MapPin.svg";
import MapPinStart from "../../../../assets/icons/MapPinStart.svg";
import { MapPinProps } from "../types";

export const useMapPins = ({ isLoaded }: MapPinProps) => {
  const waypointPin = useMemo<google.maps.Icon | undefined>(() => {
    if (!isLoaded) return undefined;
    return {
      url: MapPin,
      scaledSize: new window.google.maps.Size(28, 28),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(14, 14),
      labelOrigin: new window.google.maps.Point(11, 7),
    };
  }, [isLoaded]);

  const startPin = useMemo<google.maps.Icon | undefined>(() => {
    if (!isLoaded) return undefined;
    return {
      url: MapPinStart,
      scaledSize: new window.google.maps.Size(28, 28),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(14, 14),
      labelOrigin: new window.google.maps.Point(11, 7),
    };
  }, [isLoaded]);

  const driverPin = useMemo<google.maps.Icon | undefined>(() => {
    if (!isLoaded) return undefined;

    // Create truck icon SVG - larger and more prominent
    const truckSvg = `
      <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="truck-shadow" x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow dx="0" dy="3" stdDeviation="4" flood-color="#FF6B3560" flood-opacity="0.6"/>
          </filter>
          <!-- Pulsing animation -->
          <animate id="pulse" attributeName="r" values="18;22;18" dur="2s" repeatCount="indefinite"/>
        </defs>
        
        <!-- Outer pulsing ring for visibility -->
        <circle cx="20" cy="20" r="18" fill="none" stroke="#FF6B35" stroke-width="2" opacity="0.4">
          <animate attributeName="r" values="18;24;18" dur="2s" repeatCount="indefinite"/>
          <animate attributeName="opacity" values="0.4;0.1;0.4" dur="2s" repeatCount="indefinite"/>
        </circle>
        
        <!-- Background circle with stronger shadow -->
        <circle cx="20" cy="20" r="17" fill="white" filter="url(#truck-shadow)" stroke="#FF6B35" stroke-width="1"/>
        
        <!-- Truck icon background - larger and more prominent -->
        <circle cx="20" cy="20" r="15" fill="#FF6B35" stroke="white" stroke-width="2" />
        
        <!-- Truck icon - bigger and clearer -->
        <g transform="translate(10, 12) scale(1.0)" fill="white" stroke="white" stroke-width="0.3">
          <path d="M15.5 10.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm0 0a2.225 2.225 0 0 0-1.666.75H12m3.5-.75a2.225 2.225 0 0 1 1.666.75H19V7m-7 4V3h5l2 4m-7 4H6.166a2.225 2.225 0 0 0-1.666-.75M12 11V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v9h1.834a2.225 2.225 0 0 1 1.666-.75M19 7h-6m-8.5 3.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z"/>
        </g>
      </svg>
    `;

    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(truckSvg)}`,
      scaledSize: new window.google.maps.Size(40, 40),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(20, 20),
    };
  }, [isLoaded]);

  return {
    waypointPin,
    startPin,
    driverPin,
  };
};
